module.exports = __webpack_public_path__ + "c089652c7ba4c80f3e79be941486a17c.png";